import React, { useState, useEffect, useRef } from 'react';
import styled from 'styled-components';
import { useNavigate } from 'react-router-dom';
import { IoChevronBack, IoChevronForward } from 'react-icons/io5';
import { 
  FaUser,
  FaUserCheck, 
  FaImage, 
  FaPhone, 
  FaMapMarkerAlt,
  FaEnvelope,
  FaFileContract,
  FaShieldAlt,
  FaInfoCircle,
  FaCheckCircle,
  FaLock
} from 'react-icons/fa';
import DaumPostcode from 'react-daum-postcode';
import { useNoobookContext } from '../context/NoobookContext';
import { useUserInfoQuery } from '../react-queries/queries';
import { getAccessToken } from '../react-queries/queries';
import { uploadUserImageFile, modifyUserName, modifyHandphoneNum, modifyMailingAddress, inputEmail, resetEmailConfirmation, confirmEmail, modifyPasswd } from '../api/UserAuthApi';
import { processApiResponse } from '../common/errorMessage';
import LoadingOverlay from '../components/LoadingOverlay';
import MessageModal from '../components/MessageModal';



const Wrapper = styled.div`
  max-width: 480px;
  margin: 0 auto;
  background: #f5f5f7;
  min-height: 100vh;
`;

const Header = styled.div`
  display: flex;
  align-items: center;
  padding: 16px 20px;
  background: #fff;
  border-bottom: 1px solid #e5e5e7;
`;

const BackButton = styled.button`
  background: none;
  border: none;
  font-size: 24px;
  color: #000;
  cursor: pointer;
  padding: 8px;
  margin-right: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const HeaderTitle = styled.h1`
  font-size: 20px;
  font-weight: 700;
  color: #000;
  margin: 0;
`;

const Content = styled.div`
  padding: 20px 16px;
`;

const Section = styled.div`
  margin-bottom: 24px;
`;

const SectionTitle = styled.h2`
  font-size: 13px;
  font-weight: 600;
  color: #8e8e93;
  margin: 0 0 8px 4px;
  text-transform: uppercase;
`;

const SectionCard = styled.div`
  background: #fff;
  border-radius: 12px;
  overflow: hidden;
`;

const SettingItem = styled.div`
  display: flex;
  align-items: center;
  padding: 12px 16px;
  border-bottom: ${props => props.last ? 'none' : '1px solid #e5e5e7'};
  cursor: ${props => props.clickable ? 'pointer' : 'default'};
  transition: background-color 0.2s;
  
  &:hover {
    background-color: ${props => props.clickable ? '#f5f5f7' : 'transparent'};
  }
`;

const SettingIcon = styled.div`
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background: ${props => props.bgColor || '#f5f5f7'};
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 12px;
  color: ${props => props.iconColor || '#000'};
  font-size: 16px;
`;

const SettingContent = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
`;

const SettingLabel = styled.div`
  font-size: 16px;
  color: #000;
  margin-bottom: 2px;
`;

const SettingValue = styled.div`
  font-size: 14px;
  color: #8e8e93;
`;

const SettingRight = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  color: #8e8e93;
  font-size: 14px;
`;

const ProfileImageWrapper = styled.div`
  width: 48px;
  height: 48px;
  border-radius: 50%;
  background: #e0e0e0;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  margin-right: 12px;
`;

const ProfileImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

const ProfileImagePlaceholder = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #bbb;
  font-size: 24px;
`;

const Input = styled.input`
  border: none;
  outline: none;
  font-size: 16px;
  color: #000;
  background: transparent;
  width: 100%;
  padding: 0;
  
  &::placeholder {
    color: #8e8e93;
  }
`;

const Textarea = styled.textarea`
  border: none;
  outline: none;
  font-size: 16px;
  color: #000;
  background: transparent;
  width: 100%;
  padding: 0;
  resize: none;
  min-height: 60px;
  
  &::placeholder {
    color: #8e8e93;
  }
`;

const EditButton = styled.button`
  background: none;
  border: none;
  color: #007aff;
  font-size: 14px;
  cursor: pointer;
  padding: 4px 8px;
  
  &:hover {
    opacity: 0.7;
  }
`;

const SaveButton = styled.button`
  background: #007aff;
  border: none;
  color: #fff;
  font-size: 14px;
  cursor: pointer;
  padding: 6px 12px;
  border-radius: 6px;
  font-weight: 500;
  
  &:hover {
    opacity: 0.8;
  }
  
  &:disabled {
    background: #c7c7cc;
    cursor: not-allowed;
  }
`;

const CancelButton = styled.button`
  background: none;
  border: none;
  color: #8e8e93;
  font-size: 14px;
  cursor: pointer;
  padding: 6px 12px;
  
  &:hover {
    opacity: 0.7;
  }
`;

const AddressValue = styled.div`
  font-size: 14px;
  color: #8e8e93;
  line-height: 1.5;
  margin-top: 4px;
`;

const AddressLine = styled.div`
  margin-bottom: 2px;
  
  &:last-child {
    margin-bottom: 0;
  }
`;

const PostcodeModal = styled.div`

 position: fixed;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 100%;
  max-width: 480px;
  height: 90vh;
  background: rgba(0, 0, 0, 0.5);
  z-index: 2000;
  display: flex;
  flex-direction: column;
  padding: 20px;
`;

/*
 position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  max-width: 480px;
  max-height: 100vh;
  background: rgba(0, 0, 0, 0.5);
  z-index: 2000;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
*/


const PostcodeModalContent = styled.div`
background: #fff;
  flex: 1;
  overflow-y: auto;
`;

/* 
  background: #fff;
  border-radius: 12px;
  width: 100%;
  max-width: 460px;
  max-height: 90vh;
  overflow: hidden;
  display: flex;
  flex-direction: column;
*/

const PostcodeModalHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 20px;
  border-bottom: 1px solid #e5e5e7;
`;

const PostcodeModalTitle = styled.div`
  font-size: 18px;
  font-weight: 600;
  color: #000;
`;

const PostcodeCloseButton = styled.button`
  background: none;
  border: none;
  font-size: 24px;
  color: #8e8e93;
  cursor: pointer;
  padding: 4px;
  
  &:hover {
    color: #000;
  }
`;

const PostcodeModalBody = styled.div`
  padding: 20px;
  overflow-y: auto;
`;

const AddressDetailInput = styled(Input)`
  margin-top: 12px;
  padding: 8px 0;
  border-bottom: 1px solid #e5e5e7;
`;

const AddressDisplay = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 0;
  border-bottom: 1px solid #e5e5e7;
`;

const AddressInfo = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

const AddressText = styled.div`
  font-size: 14px;
  color: #000;
  line-height: 1.4;
`;

const SearchButton = styled.button`
  background: #007aff;
  border: none;
  color: #fff;
  font-size: 14px;
  cursor: pointer;
  padding: 6px 12px;
  border-radius: 6px;
  font-weight: 500;
  white-space: nowrap;
  margin-left: 12px;
  
  &:hover {
    opacity: 0.8;
  }
  
  &:disabled {
    background: #c7c7cc;
    cursor: not-allowed;
  }
`;

const PostcodeModalFooter = styled.div`
  display: flex;
  gap: 8px;
  padding: 16px 20px;
  border-top: 1px solid #e5e5e7;
  justify-content: flex-end;
`;

const EmailModal = styled.div`
  position: fixed;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 100%;
  max-width: 480px;
  height: 100vh;
  background: rgba(0, 0, 0, 0.5);
  z-index: 2000;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
`;

const EmailModalContent = styled.div`
  background: #fff;
  border-radius: 12px;
  width: 100%;
  max-width: 400px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
`;

const EmailModalHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 20px;
  border-bottom: 1px solid #e5e5e7;
`;

const EmailModalTitle = styled.div`
  font-size: 18px;
  font-weight: 600;
  color: #000;
`;

const EmailModalBody = styled.div`
  padding: 20px;
`;

const EmailInput = styled(Input)`
  width: 100%;
  padding: 12px 0;
  border-bottom: 1px solid #e5e5e7;
  margin-bottom: 20px;
`;

const PasswordInput = styled(Input)`
  width: 100%;
  padding: 12px 0;
  border-bottom: 1px solid #e5e5e7;
  margin-bottom: 16px;

  &:last-of-type {
    margin-bottom: 0;
  }
`;

const ConfirmCodeInput = styled(Input)`
  width: 100%;
  padding: 12px 0;
  border-bottom: 1px solid #e5e5e7;
  margin-bottom: 12px;
`;

const EmailModalFooter = styled.div`
  display: flex;
  gap: 8px;
  padding: 16px 20px;
  border-top: 1px solid #e5e5e7;
  justify-content: flex-end;
`;

const ResendButton = styled.button`
  background: none;
  border: none;
  color: #007aff;
  font-size: 14px;
  cursor: pointer;
  padding: 6px 12px;
  
  &:hover {
    opacity: 0.7;
  }
`;

const EmailStatus = styled.span`
  font-size: 12px;
  color: #8e8e93;
  margin-left: 8px;
`;

export default function SettingsPage() {
  const navigate = useNavigate();
  const { showBack, setShowBack, logoText, setLogoText } = useNoobookContext();
  const { data: userInfo, refetch: refetchUserInfo } = useUserInfoQuery();
  
  const [editingField, setEditingField] = useState(null);
  const [formData, setFormData] = useState({
    name: '',
    phone: '',
    address: '',
    addressDetail: '',
    postalCode: '',
    profileImage: null
  });
  const [loading, setLoading] = useState(false);
  const [messageModal, setMessageModal] = useState({ show: false, message: '' });
  const [showPostcodeModal, setShowPostcodeModal] = useState(false);
  const [showPostcodeSearch, setShowPostcodeSearch] = useState(false);
  const [tempAddressDetail, setTempAddressDetail] = useState('');
  const [profileImgUrl, setProfileImgUrl] = useState('');
  const addressDetailInputRef = useRef(null);
  const [showEmailModal, setShowEmailModal] = useState(false);
  const [showEmailConfirmModal, setShowEmailConfirmModal] = useState(false);
  const [tempEmail, setTempEmail] = useState('');
  const [confirmCode, setConfirmCode] = useState('');
  const [showPasswordModal, setShowPasswordModal] = useState(false);
  const [currentPasswd, setCurrentPasswd] = useState('');
  const [newPasswd, setNewPasswd] = useState('');
  const [newPasswdConfirm, setNewPasswdConfirm] = useState('');

  useEffect(() => {
    var prevShowBack = showBack;
    var prevLogoText = logoText;
    setShowBack(true);
    setLogoText('설정');
    
    if (userInfo) {
      setFormData({
        name: userInfo.name || '',
        phone: userInfo?.handphoneNum || '',
        address: userInfo?.mailingAddr || '',
        addressDetail: userInfo?.mailingAddrDetail || '',
        postalCode: userInfo?.mailingPostalCode || '',
        profileImage: null
      });
      setProfileImgUrl(userInfo?.imgFileUrl || '');
    }
    console.log("user info:", userInfo);
    
    return () => {
      setShowBack(prevShowBack);
      setLogoText(prevLogoText);
    };
  }, [userInfo]);

  const handleBack = () => {
    navigate(-1);
  };

  const handleEdit = (field) => {
    setEditingField(field);
  };

  const handleCancel = () => {
    setEditingField(null);
    if (userInfo) {
      setFormData({
        name: userInfo.name || '',
        phone: userInfo?.handphoneNum || '',
        address: userInfo?.mailingAddr || '',
        addressDetail: userInfo?.mailingAddrDetail || '',
        postalCode: userInfo?.mailingPostalCode || '',
        profileImage: formData.profileImage
      });
    }
  };

  const handleSave = async (field) => {
    setLoading(true);
    try {
      const { accessToken } = await getAccessToken();
      if (!accessToken) {
        setMessageModal({ show: true, message: '로그인이 필요합니다.' });
        return;
      }

      if (field === 'name') {
        if (!formData.name || formData.name.trim() === '') {
          setMessageModal({ show: true, message: '이름을 입력해주세요.' });
          return;
        }

        const res = await modifyUserName(accessToken, formData.name.trim());
        const processedResponse = processApiResponse(res);

        if (processedResponse.success && processedResponse.data) {
          setMessageModal({ show: true, message: '이름이 변경되었습니다.' });
          setEditingField(null);
          await refetchUserInfo();
        } else {
          console.error('이름 변경 중 오류 발생:', processedResponse.errorMessage);
          setMessageModal({ show: true, message: processedResponse.errorMessage || '이름 변경에 실패했습니다.' });
        }
      } else if (field === 'phone') {
        if (!formData.phone || formData.phone.trim() === '') {
          setMessageModal({ show: true, message: '핸드폰 번호를 입력해주세요.' });
          return;
        }

        const res = await modifyHandphoneNum(accessToken, formData.phone.trim());
        const processedResponse = processApiResponse(res);

        if (processedResponse.success && processedResponse.data) {
          setMessageModal({ show: true, message: '핸드폰 번호가 변경되었습니다.' });
          setEditingField(null);
          await refetchUserInfo();
        } else {
          console.error('핸드폰 번호 변경 중 오류 발생:', processedResponse.errorMessage);
          setMessageModal({ show: true, message: processedResponse.errorMessage || '핸드폰 번호 변경에 실패했습니다.' });
        }
      } else {
        // TODO: 다른 필드들도 필요시 추가
        setMessageModal({ show: true, message: '저장되었습니다.' });
        setEditingField(null);
        await refetchUserInfo();
      }
    } catch (error) {
      console.error('저장 중 오류 발생:', error);
      setMessageModal({ show: true, message: '저장 중 오류가 발생했습니다.' });
    } finally {
      setLoading(false);
    }
  };

  const handleInputChange = (field, value) => {
    setFormData(prev => ({
      ...prev,
      [field]: value
    }));
  };

  const handleProfileImageChange = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    // 파일 타입 검증
    if (!file.type.startsWith('image/')) {
      setMessageModal({ show: true, message: '이미지 파일만 업로드 가능합니다.' });
      return;
    }

    // 파일 크기 검증 (예: 5MB)
    const maxSize = 5 * 1024 * 1024; // 5MB
    if (file.size > maxSize) {
      setMessageModal({ show: true, message: '이미지 크기는 5MB 이하여야 합니다.' });
      return;
    }

    setLoading(true);
    try {
      const { accessToken } = await getAccessToken();
      if (!accessToken) {
        setMessageModal({ show: true, message: '로그인이 필요합니다.' });
        return;
      }

      const res = await uploadUserImageFile(accessToken, file);
      const processedResponse = processApiResponse(res);

      if (processedResponse.success && processedResponse.data) {
        // 업로드 성공 시 미리보기 업데이트
        setFormData(prev => ({
          ...prev,
          profileImage: file
        }));
        
        // 사용자 정보 다시 가져오기
        await refetchUserInfo();
        
        // 업데이트된 이미지 URL 설정
        if (processedResponse.data.imgFileUrl) {
          setProfileImgUrl(processedResponse.data.imgFileUrl);
        }
        
        setMessageModal({ show: true, message: '프로필 이미지가 변경되었습니다.' });
      } else {
        console.error('프로필 이미지 업로드 중 오류 발생:', processedResponse.errorMessage);
        setMessageModal({ show: true, message: processedResponse.errorMessage || '프로필 이미지 업로드에 실패했습니다.' });
      }
    } catch (error) {
      console.error('프로필 이미지 업로드 중 오류 발생:', error);
      setMessageModal({ show: true, message: '프로필 이미지 업로드 중 오류가 발생했습니다.' });
    } finally {
      setLoading(false);
      // 파일 input 초기화 (같은 파일을 다시 선택할 수 있도록)
      e.target.value = '';
    }
  };

  const handlePostcodeComplete = (data) => {
    let fullAddress = data.address;
    let extraAddress = '';

    if (data.addressType === 'R') {
      if (data.bname !== '') {
        extraAddress += data.bname;
      }
      if (data.buildingName !== '') {
        extraAddress += (extraAddress !== '' ? `, ${data.buildingName}` : data.buildingName);
      }
      fullAddress += (extraAddress !== '' ? ` (${extraAddress})` : '');
    }

    // 주소 선택 시 우편번호와 기본 주소만 먼저 설정
    setFormData(prev => ({
      ...prev,
      postalCode: data.zonecode,
      address: fullAddress
    }));
    
    // DaumPostcode 숨기기
    setShowPostcodeSearch(false);
    
    // AddressDetailInput에 포커스 이동
    setTimeout(() => {
      if (addressDetailInputRef.current) {
        addressDetailInputRef.current.focus();
      }
    }, 100);
  };

  const handleAddressSave = async () => {
    if (!formData.postalCode || !formData.address) {
      setMessageModal({ show: true, message: '주소를 선택해주세요.' });
      return;
    }

    setLoading(true);
    try {
      const { accessToken } = await getAccessToken();
      if (!accessToken) {
        setMessageModal({ show: true, message: '로그인이 필요합니다.' });
        return;
      }

      const mailingAddr = formData.address || '';
      const mailingAddrDetail = tempAddressDetail || formData.addressDetail || '';
      const mailingPostalCode = formData.postalCode || '';

      const res = await modifyMailingAddress(accessToken, mailingAddr, mailingAddrDetail, mailingPostalCode);
      const processedResponse = processApiResponse(res);

      if (processedResponse.success && processedResponse.data) {
        // 저장 성공 시 formData 업데이트
        setFormData(prev => ({
          ...prev,
          addressDetail: tempAddressDetail || prev.addressDetail
        }));
        
        setMessageModal({ show: true, message: '수신지 주소가 변경되었습니다.' });
        setShowPostcodeModal(false);
        setTempAddressDetail('');
        
        // 사용자 정보 다시 가져오기
        await refetchUserInfo();
      } else {
        console.error('수신지 주소 변경 중 오류 발생:', processedResponse.errorMessage);
        setMessageModal({ show: true, message: processedResponse.errorMessage || '수신지 주소 변경에 실패했습니다.' });
      }
    } catch (error) {
      console.error('수신지 주소 변경 중 오류 발생:', error);
      setMessageModal({ show: true, message: '수신지 주소 변경 중 오류가 발생했습니다.' });
    } finally {
      setLoading(false);
    }
  };

  const handleAddressChange = () => {
    setTempAddressDetail(formData.addressDetail);
    setShowPostcodeModal(true);
    setShowPostcodeSearch(false);
  };

  const handleSearchAddress = () => {
    setShowPostcodeSearch(true);
  };

  const handlePostcodeModalClose = () => {
    setShowPostcodeModal(false);
    setShowPostcodeSearch(false);
    setTempAddressDetail('');
  };

  const handleBugReport = () => {
    // TODO: 버그 제보 기능 구현
    setMessageModal({ show: true, message: '버그 제보 기능은 준비 중입니다.' });
  };

  const handleTerms = () => {
    navigate('/terms/service');
  };

  const handlePrivacy = () => {
    navigate('/terms/privacy');
  };

  const handleEmailChange = () => {
    setTempEmail(userInfo?.email || '');
    setShowEmailModal(true);
  };

  const handlePasswordChange = () => {
    setCurrentPasswd('');
    setNewPasswd('');
    setNewPasswdConfirm('');
    setShowPasswordModal(true);
  };

  const handlePasswordModalClose = () => {
    setShowPasswordModal(false);
    setCurrentPasswd('');
    setNewPasswd('');
    setNewPasswdConfirm('');
  };

  const handlePasswordSave = async () => {
    if (!currentPasswd.trim()) {
      setMessageModal({ show: true, message: '현재 비밀번호를 입력해주세요.' });
      return;
    }
    if (!newPasswd.trim()) {
      setMessageModal({ show: true, message: '새 비밀번호를 입력해주세요.' });
      return;
    }
    if (!newPasswdConfirm.trim()) {
      setMessageModal({ show: true, message: '새 비밀번호 확인을 입력해주세요.' });
      return;
    }
    if (newPasswd !== newPasswdConfirm) {
      setMessageModal({ show: true, message: '새 비밀번호가 일치하지 않습니다.' });
      return;
    }
    if (currentPasswd === newPasswd) {
      setMessageModal({ show: true, message: '새 비밀번호는 현재 비밀번호와 달라야 합니다.' });
      return;
    }

    setLoading(true);
    try {
      const { accessToken } = await getAccessToken();
      if (!accessToken) {
        setMessageModal({ show: true, message: '로그인이 필요합니다.' });
        return;
      }

      const res = await modifyPasswd(accessToken, {
        currentPasswd: currentPasswd,
        newPasswd: newPasswd,
      });
      const processedResponse = processApiResponse(res);

      if (processedResponse.success && processedResponse.data) {
        setMessageModal({ show: true, message: '비밀번호가 변경되었습니다.' });
        handlePasswordModalClose();
        await refetchUserInfo();
      } else {
        console.error('비밀번호 변경 중 오류 발생:', processedResponse.errorMessage);
        setMessageModal({ show: true, message: processedResponse.errorMessage || '비밀번호 변경에 실패했습니다.' });
      }
    } catch (error) {
      console.error('비밀번호 변경 중 오류 발생:', error);
      setMessageModal({ show: true, message: '비밀번호 변경 중 오류가 발생했습니다.' });
    } finally {
      setLoading(false);
    }
  };

  const handleEmailSave = async () => {
    if (!tempEmail || !tempEmail.trim()) {
      setMessageModal({ show: true, message: '이메일을 입력해주세요.' });
      return;
    }

    // 이메일 형식 검증
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(tempEmail.trim())) {
      setMessageModal({ show: true, message: '올바른 이메일 형식을 입력해주세요.' });
      return;
    }

    setLoading(true);
    try {
      const { accessToken } = await getAccessToken();
      if (!accessToken) {
        setMessageModal({ show: true, message: '로그인이 필요합니다.' });
        return;
      }

      const res = await inputEmail(accessToken, tempEmail.trim());
      const processedResponse = processApiResponse(res);

      if (processedResponse.success) {
        setMessageModal({ show: true, message: '이메일이 등록되었습니다. 인증을 완료해주세요.' });
        setShowEmailModal(false);
        setTempEmail('');
        await refetchUserInfo();
      } else {
        console.error('이메일 등록 중 오류 발생:', processedResponse.errorMessage);
        setMessageModal({ show: true, message: processedResponse.errorMessage || '이메일 등록에 실패했습니다.' });
      }
    } catch (error) {
      console.error('이메일 등록 중 오류 발생:', error);
      setMessageModal({ show: true, message: '이메일 등록 중 오류가 발생했습니다.' });
    } finally {
      setLoading(false);
    }
  };

  const handleEmailConfirm = () => {
    setConfirmCode('');
    setShowEmailConfirmModal(true);
  };

  const handleConfirmCodeSubmit = async () => {
    if (!confirmCode || !confirmCode.trim()) {
      setMessageModal({ show: true, message: '인증코드를 입력해주세요.' });
      return;
    }

    setLoading(true);
    try {
      const { accessToken } = await getAccessToken();
      if (!accessToken) {
        setMessageModal({ show: true, message: '로그인이 필요합니다.' });
        return;
      }

      const res = await confirmEmail(accessToken, confirmCode.trim());
      const processedResponse = processApiResponse(res);

      if (processedResponse.success && processedResponse.data) {
        setMessageModal({ show: true, message: '이메일 인증이 완료되었습니다.' });
        setShowEmailConfirmModal(false);
        setConfirmCode('');
        await refetchUserInfo();
      } else {
        console.error('이메일 인증 중 오류 발생:', processedResponse?.errorMessage);
        setMessageModal({ show: true, message: processedResponse?.errorMessage || '인증코드가 올바르지 않습니다.' });
      }
    } catch (error) {
      console.error('이메일 인증 중 오류 발생:', error);
      setMessageModal({ show: true, message: '이메일 인증 중 오류가 발생했습니다.' });
    } finally {
      setLoading(false);
    }
  };

  const handleResendConfirmCode = async () => {
    setLoading(true);
    try {
      const { accessToken } = await getAccessToken();
      if (!accessToken) {
        setMessageModal({ show: true, message: '로그인이 필요합니다.' });
        return;
      }

      const res = await resetEmailConfirmation(accessToken);
      const processedResponse = processApiResponse(res);

      if (processedResponse.success) {
        setMessageModal({ show: true, message: '인증 코드를 메일로 발송하였습니다. 메일로 발송한 인증코드를 입력하여 인증을 완료해 주세요.' });
      } else {
        console.error('인증코드 재발송 중 오류 발생:', processedResponse.errorMessage);
        setMessageModal({ show: true, message: processedResponse.errorMessage || '인증코드 재발송에 실패했습니다.' });
      }
    } catch (error) {
      console.error('인증코드 재발송 중 오류 발생:', error);
      setMessageModal({ show: true, message: '인증코드 재발송 중 오류가 발생했습니다.' });
    } finally {
      setLoading(false);
    }
  };

  const appVersion = '1.24.3'; // package.json의 version과 다를 수 있음

  return (
    <Wrapper>
     {/* <Header>
        <BackButton onClick={handleBack}>
          <IoChevronBack />
        </BackButton>
        <HeaderTitle>설정</HeaderTitle>
      </Header> */}

      <Content>
        {/* 사용자 정보 섹션 */}
        <Section>
          <SectionTitle>사용자 정보</SectionTitle>
          <SectionCard>
            {/* 이름 */}
            <SettingItem>
              <SettingIcon bgColor="#f5f5f7" iconColor="#8e8e93">
                <FaUserCheck />
              </SettingIcon>
              <SettingContent>
                {editingField === 'name' ? (
                  <Input
                    type="text"
                    value={formData.name}
                    onChange={(e) => handleInputChange('name', e.target.value)}
                    placeholder="이름을 입력하세요"
                    autoFocus
                  />
                ) : (
                  <>
                    <SettingLabel>이름</SettingLabel>
                    <SettingValue>{formData.name || '이름을 입력하세요'}</SettingValue>
                  </>
                )}
              </SettingContent>
              <SettingRight>
                {editingField === 'name' ? (
                  <>
                    <CancelButton onClick={handleCancel}>취소</CancelButton>
                    <SaveButton onClick={() => handleSave('name')} disabled={loading}>
                      저장
                    </SaveButton>
                  </>
                ) : (
                  <EditButton onClick={() => handleEdit('name')}>수정</EditButton>
                )}
              </SettingRight>
            </SettingItem>

            {/* 프로파일 이미지 */}
            <SettingItem>
              <ProfileImageWrapper>
                {formData.profileImage ? (
                  <ProfileImage src={URL.createObjectURL(formData.profileImage)} alt="프로필" />
                ) : profileImgUrl? (
                   <ProfileImage src={profileImgUrl} alt="프로필"/>
                ) : (
                  <ProfileImagePlaceholder>
                    <FaUser />
                  </ProfileImagePlaceholder>
                )}
              </ProfileImageWrapper>
              <SettingContent>
                <SettingLabel>프로파일 이미지</SettingLabel>
                <SettingValue>프로필 사진을 변경하세요</SettingValue>
              </SettingContent>
              <SettingRight>
                <input
                  type="file"
                  accept="image/*"
                  onChange={handleProfileImageChange}
                  style={{ display: 'none' }}
                  id="profile-image-input"
                />
                <EditButton as="label" htmlFor="profile-image-input" style={{ cursor: 'pointer' }}>
                  변경
                </EditButton>
              </SettingRight>
            </SettingItem>

            {/* 이메일 */}
            <SettingItem>
              <SettingIcon bgColor="#f5f5f7" iconColor="#8e8e93">
                <FaEnvelope />
              </SettingIcon>
              <SettingContent>
                <SettingLabel>이메일</SettingLabel>
                <SettingValue>
                  {userInfo?.email || '이메일을 입력하세요'}
                  {userInfo?.email && userInfo?.emailConfirmed && (
                    <EmailStatus>(인증완료)</EmailStatus>
                  )}
                </SettingValue>
              </SettingContent>
              <SettingRight>
                {userInfo?.email && !userInfo?.emailConfirmed && (
                  <EditButton onClick={handleEmailConfirm}>인증</EditButton>
                ) }
              </SettingRight>
              <SettingRight>
                {(
                  <EditButton onClick={handleEmailChange}>변경</EditButton>
                )}
              </SettingRight>
            </SettingItem>

            {/* 비밀번호 */}
            <SettingItem>
              <SettingIcon bgColor="#f5f5f7" iconColor="#8e8e93">
                <FaLock />
              </SettingIcon>
              <SettingContent>
                <SettingLabel>비밀번호</SettingLabel>
                <SettingValue>••••••••</SettingValue>
              </SettingContent>
              <SettingRight>
                <EditButton onClick={handlePasswordChange}>변경</EditButton>
              </SettingRight>
            </SettingItem>

            {/* 핸드폰 번호 */}
            <SettingItem>
              <SettingIcon bgColor="#f5f5f7" iconColor="#8e8e93">
                <FaPhone />
              </SettingIcon>
              <SettingContent>
                {editingField === 'phone' ? (
                  <Input
                    type="tel"
                    value={formData.phone}
                    onChange={(e) => handleInputChange('phone', e.target.value)}
                    placeholder="핸드폰 번호를 입력하세요"
                    autoFocus
                  />
                ) : (
                  <>
                    <SettingLabel>핸드폰 번호</SettingLabel>
                    <SettingValue>{formData.phone || '핸드폰 번호를 입력하세요'}</SettingValue>
                  </>
                )}
              </SettingContent>
              <SettingRight>
                {editingField === 'phone' ? (
                  <>
                    <CancelButton onClick={handleCancel}>취소</CancelButton>
                    <SaveButton onClick={() => handleSave('phone')} disabled={loading}>
                      저장
                    </SaveButton>
                  </>
                ) : (
                  <EditButton onClick={() => handleEdit('phone')}>수정</EditButton>
                )}
              </SettingRight>
            </SettingItem>

            {/* 수신지 주소 */}
            <SettingItem last>
              <SettingIcon bgColor="#f5f5f7" iconColor="#8e8e93">
                <FaMapMarkerAlt />
              </SettingIcon>
              <SettingContent>
                <SettingLabel>수신지 주소</SettingLabel>
                {formData.postalCode || formData.address || formData.addressDetail ? (
                  <AddressValue>
                    {formData.postalCode && (
                      <AddressLine>우편번호: {formData.postalCode}</AddressLine>
                    )}
                    {formData.address && (
                      <AddressLine>기본 주소: {formData.address}</AddressLine>
                    )}
                    {formData.addressDetail && (
                      <AddressLine>상세 주소: {formData.addressDetail}</AddressLine>
                    )}
                  </AddressValue>
                ) : (
                  <SettingValue>수신지 주소를 입력하세요</SettingValue>
                )}
              </SettingContent>
              <SettingRight>
                <EditButton onClick={handleAddressChange}>변경</EditButton>
              </SettingRight>
            </SettingItem>
          </SectionCard>
        </Section>

        {/* 지원 섹션 */}
        <Section>
          <SectionTitle>지원</SectionTitle>
          <SectionCard>
            <SettingItem clickable last onClick={handleBugReport}>
              <SettingIcon bgColor="#f5f5f7" iconColor="#8e8e93">
                <FaEnvelope />
              </SettingIcon>
              <SettingContent>
                <SettingLabel>버그/오류 제보</SettingLabel>
              </SettingContent>
              <SettingRight>
                <IoChevronForward />
              </SettingRight>
            </SettingItem>
          </SectionCard>
        </Section>

        {/* 정보 섹션 */}
        <Section>
          <SectionTitle>정보</SectionTitle>
          <SectionCard>
            <SettingItem clickable onClick={handleTerms}>
              <SettingIcon bgColor="#f5f5f7" iconColor="#8e8e93">
                <FaFileContract />
              </SettingIcon>
              <SettingContent>
                <SettingLabel>서비스 이용약관</SettingLabel>
              </SettingContent>
              <SettingRight>
                <IoChevronForward />
              </SettingRight>
            </SettingItem>
            <SettingItem clickable onClick={handlePrivacy}>
              <SettingIcon bgColor="#f5f5f7" iconColor="#8e8e93">
                <FaShieldAlt />
              </SettingIcon>
              <SettingContent>
                <SettingLabel>개인정보처리방침</SettingLabel>
              </SettingContent>
              <SettingRight>
                <IoChevronForward />
              </SettingRight>
            </SettingItem>
            <SettingItem last>
              <SettingIcon bgColor="#f5f5f7" iconColor="#8e8e93">
                <FaInfoCircle />
              </SettingIcon>
              <SettingContent>
                <SettingLabel>앱 버전</SettingLabel>
              </SettingContent>
              <SettingRight>
                {appVersion}
              </SettingRight>
            </SettingItem>
          </SectionCard>
        </Section>
      </Content>

      {loading && <LoadingOverlay />}
      {messageModal.show && (
        <MessageModal
          isOpen={messageModal.show}
          message={messageModal.message}
          onClose={() => setMessageModal({ show: false, message: '' })}
        />
      )}
      
      {showPostcodeModal && (
        <PostcodeModal onClick={handlePostcodeModalClose}>
          <PostcodeModalContent onClick={(e) => e.stopPropagation()}>
            <PostcodeModalHeader>
              <PostcodeModalTitle>주소 검색</PostcodeModalTitle>
              <PostcodeCloseButton onClick={handlePostcodeModalClose}>×</PostcodeCloseButton>
            </PostcodeModalHeader>
            <PostcodeModalBody>
              {showPostcodeSearch ? (
                <DaumPostcode
                  onComplete={handlePostcodeComplete}
                  autoClose={false}
                  style={{ height: '400px' }}
                />
              ) : (
                <>
                  <AddressDisplay>
                    <AddressInfo>
                      {formData.postalCode && (
                        <AddressText>우편번호: {formData.postalCode}</AddressText>
                      )}
                      {formData.address && (
                        <AddressText>{formData.address}</AddressText>
                      )}
                      {!formData.postalCode && !formData.address && (
                        <AddressText style={{ color: '#8e8e93' }}>주소를 검색해주세요</AddressText>
                      )}
                    </AddressInfo>
                    <SearchButton onClick={handleSearchAddress}>조회</SearchButton>
                  </AddressDisplay>
                  <AddressDetailInput
                    ref={addressDetailInputRef}
                    type="text"
                    placeholder="상세 주소를 입력하세요 (선택사항)"
                    value={tempAddressDetail}
                    onChange={(e) => setTempAddressDetail(e.target.value)}
                  />
                </>
              )}
            </PostcodeModalBody>
            <PostcodeModalFooter>
              <CancelButton onClick={handlePostcodeModalClose}>취소</CancelButton>
              <SaveButton onClick={handleAddressSave} disabled={!formData.postalCode}>
                저장
              </SaveButton>
            </PostcodeModalFooter>
          </PostcodeModalContent>
        </PostcodeModal>
      )}

      {/* 이메일 입력 모달 */}
      {showEmailModal && (
        <EmailModal onClick={() => setShowEmailModal(false)}>
          <EmailModalContent onClick={(e) => e.stopPropagation()}>
            <EmailModalHeader>
              <EmailModalTitle>이메일 변경</EmailModalTitle>
              <PostcodeCloseButton onClick={() => setShowEmailModal(false)}>×</PostcodeCloseButton>
            </EmailModalHeader>
            <EmailModalBody>
              <EmailInput
                type="email"
                placeholder="이메일을 입력하세요"
                value={tempEmail}
                onChange={(e) => setTempEmail(e.target.value)}
                autoFocus
              />
            </EmailModalBody>
            <EmailModalFooter>
              <CancelButton onClick={() => setShowEmailModal(false)}>취소</CancelButton>
              <SaveButton onClick={handleEmailSave} disabled={loading || !tempEmail.trim()}>
                저장
              </SaveButton>
            </EmailModalFooter>
          </EmailModalContent>
        </EmailModal>
      )}

      {/* 비밀번호 변경 모달 */}
      {showPasswordModal && (
        <EmailModal onClick={handlePasswordModalClose}>
          <EmailModalContent onClick={(e) => e.stopPropagation()}>
            <EmailModalHeader>
              <EmailModalTitle>비밀번호 변경</EmailModalTitle>
              <PostcodeCloseButton onClick={handlePasswordModalClose}>×</PostcodeCloseButton>
            </EmailModalHeader>
            <EmailModalBody>
              <PasswordInput
                type="password"
                placeholder="현재 비밀번호"
                value={currentPasswd}
                onChange={(e) => setCurrentPasswd(e.target.value)}
                autoFocus
              />
              <PasswordInput
                type="password"
                placeholder="새 비밀번호"
                value={newPasswd}
                onChange={(e) => setNewPasswd(e.target.value)}
              />
              <PasswordInput
                type="password"
                placeholder="새 비밀번호 확인"
                value={newPasswdConfirm}
                onChange={(e) => setNewPasswdConfirm(e.target.value)}
              />
            </EmailModalBody>
            <EmailModalFooter>
              <CancelButton onClick={handlePasswordModalClose}>취소</CancelButton>
              <SaveButton
                onClick={handlePasswordSave}
                disabled={loading || !currentPasswd.trim() || !newPasswd.trim() || !newPasswdConfirm.trim()}
              >
                저장
              </SaveButton>
            </EmailModalFooter>
          </EmailModalContent>
        </EmailModal>
      )}

      {/* 이메일 인증 모달 */}
      {showEmailConfirmModal && (
        <EmailModal onClick={() => setShowEmailConfirmModal(false)}>
          <EmailModalContent onClick={(e) => e.stopPropagation()}>
            <EmailModalHeader>
              <EmailModalTitle>이메일 인증</EmailModalTitle>
              <PostcodeCloseButton onClick={() => setShowEmailConfirmModal(false)}>×</PostcodeCloseButton>
            </EmailModalHeader>
            <EmailModalBody>
              <SettingValue style={{ marginBottom: '16px' }}>
                {userInfo?.email}로 발송된 인증코드를 입력해주세요.
              </SettingValue>
              <ConfirmCodeInput
                type="text"
                placeholder="인증코드를 입력하세요"
                value={confirmCode}
                onChange={(e) => setConfirmCode(e.target.value)}
                autoFocus
              />
            </EmailModalBody>
            <EmailModalFooter>
              <ResendButton onClick={handleResendConfirmCode} disabled={loading}>
                인증코드 재발송
              </ResendButton>
              <CancelButton onClick={() => setShowEmailConfirmModal(false)}>취소</CancelButton>
              <SaveButton onClick={handleConfirmCodeSubmit} disabled={loading || !confirmCode.trim()}>
                확인
              </SaveButton>
            </EmailModalFooter>
          </EmailModalContent>
        </EmailModal>
      )}
    </Wrapper>
  );
}

